<template>
    <div class="le-tea-center">
        <div class="pc-top-nav">
            <div class="le-center-content">
                <div class="nav-crumb-top">
                    <i class="kd-icon-dizhi" style="margin-right:8px;"></i>
                    <span @click="goHome">首页</span> >
                    <span style="color:#409EFF">个人中心</span>
                </div>
                <div class="le-personal-center">
                    <div class="nav-sidebar-left clearfix">
                        <div class="nav-sidebar-li fl" :class="{'active-tabs':tabs == 1}" @click="getNewsr(1)">
                            个人信息
                        </div> 
                        <div class="nav-sidebar-li fl" :class="{'active-tabs':tabs == 2}" @click="getNewsr(2)">
                            密码修改
                        </div> 
                        <div class="nav-sidebar-li fl" :class="{'active-tabs':tabs == 3}" @click="getNewsr(3)">
                            手机绑定
                        </div>
                    </div>
                    <el-form label-width="100px" class="change-user-password-form" v-if="tabs==1">
                        <!-- <el-form-item label="学校：">
                            <el-select filterable clearable v-model="schoolId" placeholder="请选择学校" class="form_input">
                                <el-option v-for="item in schoolInfo" :key="item.Id" :label="item.SchoolName" :value="item.Id"></el-option>
                            </el-select>
                        </el-form-item> -->
                        <el-form-item label="姓名：">
                          <el-input v-model="TeacherDisplayName" :disabled="disabled" placeholder="请输入姓名" class='yk-name'></el-input>
                          <span style='color:#EA2D55; font-size:12px;margin-left:30px'>
                            <i class='el-icon-warning'></i>
                            用户姓名无法修改
                          </span>
                        </el-form-item>
                        <el-form-item label="账号：">
                          <el-input v-model="TeacherUserName" :disabled="disabled" placeholder="请输入账号" class='yk-job-number'></el-input>
                          <span style='color:#EA2D55; font-size:12px;margin-left:30px'>
                            <i class='el-icon-warning'></i>
                            用户账号无法修改
                          </span>
                        </el-form-item>
                        <el-form-item label="性别：">
                          <el-radio-group v-model="Gender" size="medium">
                            <el-radio label="男"></el-radio>
                            <el-radio label="女"></el-radio>
                          </el-radio-group>
                        </el-form-item>
                        <el-form-item label="简介：" style='margin-bottom:40px'>
                          <el-input type="textarea" :rows="6" v-model="Description" placeholder="请输入您的简介内容" class='yk-synopsis'></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="editUserInfo">保存</el-button>
                        </el-form-item>
                    </el-form>
                    <el-form label-width="100px" class="change-user-password-form" v-if="tabs==2">
                        <el-form-item label="旧密码：">
                            <el-input placeholder="请输入旧密码" type="password" v-model="oldPassword" show-password></el-input>
                        </el-form-item>
                        <el-form-item label="新密码：">
                            <el-input placeholder="请输入新密码" type="password" v-model="Password" show-password></el-input>
                        </el-form-item>
                        <el-form-item label="确认密码：">
                            <el-input placeholder="请确认密码" type="password" v-model="replayPass" show-password></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="editPassword">密码修改</el-button>
                        </el-form-item>
                    </el-form>
                    <el-form label-width="100px" class="change-user-password-form" v-if="tabs==3 && Mobile =='未绑定'">
                        <div class='yk-unbound'>当前账号未绑定手机号</div>
                        
                        <el-form-item label="手机号：" v-if="show4" class='yk-phone-number'>
                          <el-input type="text" placeholder="请输入手机号" v-model="phoneNum"></el-input>
                        </el-form-item>
                        <el-form-item v-show="this.phoneNum == ''" class='yk-no-number'>
                          <span style='color:#EA2D55; font-size:12px;margin-left:30px'>
                              <i class='el-icon-warning'></i>
                              手机号不可为空
                          </span>
                        </el-form-item>
                        <el-form-item v-show="this.Mobile == this.phoneNum" class='yk-same-binding'>
                          <span style='color:#EA2D55; font-size:12px;margin-left:30px'>
                            <i class='el-icon-warning'></i>
                            此手机号已绑定该账号，不可重复绑定
                          </span>
                        </el-form-item>
                        <el-form-item v-show="this.phoneNum !== ''&&!(/^[1][0-9]{10}$/).test(this.phoneNum)" class='yk-right-number'>
                          <span style='color:#EA2D55; font-size:12px;margin-left:30px'>
                            <i class='el-icon-warning'></i>
                            请输入正确的手机号
                          </span>
                        </el-form-item>
                        <el-form-item label="手机号：" v-if="!show4">
                          <span style="font-size:18px;color:#ffffff">{{phoneNum}}</span>
                        </el-form-item>
                        <!-- <el-form-item label="验证码：" class="short-message-form">
                          <el-input placeholder="请输入短信验证码" v-model="shortMessage">
                            <el-button v-if="show1" slot="append" @click="sendMessage()">获取验证码</el-button>
                            <el-button v-if="show2" slot="append">{{count}}s</el-button>
                            <el-button v-if="show3" slot="append" @click="sendMessage()">重新获取验证码</el-button>
                          </el-input>
                        </el-form-item> -->
                        <!-- <el-form-item v-show="this.shortMessage == ''" class='yk-input-message'>
                          <i class='el-icon-warning'></i>
                          <span>请输入验证码</span>
                        </el-form-item> -->
                        <el-form-item class='yk-binding'>
                          <el-button type="primary" @click="bindCellPhoneNumber" style='font-size:16px;'>立即绑定</el-button>
                        </el-form-item>
                    </el-form>
                    <el-form label-width="100px" class="change-user-password-form" v-if="tabs==3 && Mobile !='未绑定'">
                          <el-form-item label="已绑手机号：" class='yk-binging-number'>
                            <span style="color:#409EFF;font-size:20px;margin-left: -10px;">{{Mobile}}</span>
                          </el-form-item>
                          <el-form-item label="手机号：" v-if="show4" class='yk-tel-number'>
                            <el-input type="text" placeholder="请输入手机号" v-model="phoneNum"></el-input>
                          </el-form-item>
                          <el-form-item v-show="this.phoneNum == ''" class='yk-no-num'>
                            <span style='color:#EA2D55; font-size:12px;margin-left:30px'>
                              <i class='el-icon-warning'></i>
                              手机号不可为空
                            </span>
                          </el-form-item>
                          <el-form-item v-show="this.Mobile == this.phoneNum" class='yk-same-bind'>
                            <span style='color:#EA2D55; font-size:12px;margin-left:30px'>
                              <i class='el-icon-warning'></i>
                              此手机号已绑定该账号，不可重复绑定
                            </span>
                          </el-form-item>
                          <el-form-item v-show="this.phoneNum !== ''&&!(/^[1][0-9]{10}$/).test(this.phoneNum)" class='yk-right-num'>
                            <span style='color:#EA2D55; font-size:12px;margin-left:30px'>
                              <i class='el-icon-warning'></i>
                              请输入正确的手机号
                            </span>
                          </el-form-item>
                          <el-form-item label="手机号：" v-if="!show4">
                            <span style="font-size:20px;">{{phoneNum}}</span>
                          </el-form-item>
                          <!-- <el-form-item label="验证码：" class="short-message-form">
                            <el-input placeholder="请输入短信验证码" v-model="shortMessage">
                              <el-button v-if="show1" slot="append" @click="sendMessage()">获取验证码</el-button>
                              <el-button v-if="show2" slot="append">{{count}}s</el-button>
                              <el-button v-if="show3" slot="append" @click="sendMessage()">重新获取验证码</el-button>
                            </el-input>
                          </el-form-item> -->
                          <!-- <el-form-item v-show="this.shortMessage == ''" class='yk-input-shortmsg'>
                            <i class='el-icon-warning'></i>
                            <span>请输入验证码</span>
                          </el-form-item> -->
                          <el-form-item class='yk-change-binging'>
                            <el-button type="primary" @click="bindPhoneAfter">更改绑定</el-button>
                          </el-form-item>
                    </el-form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {
  getTecInfo,
  ReviseTeacher,
  RevisePassword,
  saveAvatorUrl,
  getStuInfo,
  ReviseStudent,
  ReleaseWX,
  getSchoolInfo,
  saveSchoolLogoUrl,
  updateTeacherHomeWorkUrl,
  getTeachIdentification,
  bindCellPhoneNumber,
  bindPhoneAfter
} from "api/v1.common.InfoData";
import {
  sendCode
} from "api/v1.commom.login";
import CryptoJS from "crypto-js";

export default {
    data() {
        return {
            tabs: 1,
            schoolId: "",
            displayName:"",
            cardNum:"",
            Password: "",
            oldPassword: "",
            replayPass: "",
            schoolInfo: [],
            TeacherDisplayName: "",
            TeacherUserName: "",
            Gender: "",
            Description: "",
            disabled: true,
            Mobile: "",
            // 短信数据
            shortMessage: "",
            phoneNum: "",
            show1: true,
            show2: false,
            show3: false,
            show4: true,
            count: 60,
            verifyCode: "",
        };
    },
    computed: {
        userInfo() {
            return this.$store.state.auth;
        },
    },
    created() {
        //this.getSchoolInfo();
        this.getTecInfo();
    },
    methods: {
        getNewsr(index){
            this.tabs = index;
        },
        //获取学校列表
        getSchoolInfo() {
            var that = this;
            this.$http.post("/api/XOrg/XLogin/getSchoolInfo").then(function(rst) {
                if (rst.code > 0) {
                    that.schoolInfo = rst.schoolInfo;
                    that.schoolId = that.userInfo.userSchoolId;
                    that.displayName = that.userInfo.displayName;
                    that.cardNum = that.userInfo.idNumber;
                }
            });
        },
        getTecInfo(){
            var that=this;
            this.$http.post("/api/XOrg/AOrgInfo/getTecInfo")
            .then(function(rst) {
                if (rst.code > 0) {
                    that.TeacherDisplayName = that.userInfo.displayName,
                    that.TeacherUserName = that.userInfo.userName,
                    that.Gender = that.getGender(rst.teacherInfo.Gender),
                    that.Description = rst.teacherInfo.Description,
                    that.Mobile=rst.teacherInfo.Mobile
                }
            });
        },
        getGender(Gender) {
          if (Gender == 0) {
            return "男";
          } else if (Gender == 1) {
            return "女";
          }
        },
        editUserInfo(){
            var that = this;
            this.$http
                .post("/api/XOrg/AOrgInfo/editUserInfo", {                   
                    // TeacherDisplayName = this.TeacherDisplayName,
                    // TeacherUserName = this.TeacherUserName,
                    Gender: this.Gender,
                    Description: this.Description
                })
                .then(function(rst) {
                    if (rst.code > 0) {
                        that.$message.success(rst.msg);
                    } else {
                        that.$message.warning(rst.msg);
                    }
                });
        },
        editPassword() {
            var that = this;
            if (this.oldPassword == "") {
                that.$message.warning("旧密码不可为空");
                return false;
            }
            if (this.Password == "") {
                that.$message.warning("新密码不可为空");
                return false;
            }
            if (this.replayPass == "") {
                that.$message.warning("请确认密码");
                return false;
            }
            if (this.Password != this.replayPass) {
                that.$message.warning("确认密码错误，请重新输入");
                that.replayPass = "";
                return false;
            }
            this.$http
                .post("/api/XOrg/AOrgInfo/editPassword", {
                    Password: this.Password,
                    oldPassword: this.oldPassword,
                })
                .then(function(rst) {
                    if (rst.code > 0) {
                        that.cancel();
                        that.$message.success(rst.msg);
                    } else {
                        that.$message.warning(rst.msg);
                    }
                });
        },
        cancel() {
            this.Password = "";
            this.oldPassword = "";
            this.replayPass = "";
        },
        //绑定手机号
        bindCellPhoneNumber(){
            var that = this;
            if (this.phoneNum == "") {
              this.$message.warning("手机号不可为空");
              return false;
            }
            if (this.Mobile == this.phoneNum) {
              this.$message.warning("此手机号已绑定该账号，不可重复绑定");
              return false;
            }
            var myreg = /^[1][0-9]{10}$/;
            if (!myreg.test(this.phoneNum)) {
              this.$message.warning("请输入正确的手机号");
              return false;
            }
            this.$http
                .post("/api/XOrg/AOrgInfo/bindCellPhoneNumber", {
                    phoneNum: this.phoneNum
                })
                .then(function(rst) {
                    if (rst.code > 0) {
                        that.cancels();
                        that.$message.success(rst.msg);
                        that.getTecInfo();
                    } else {
                        that.$message.warning(rst.msg);
                    }
                });
        },
        //更改手机号
        bindPhoneAfter(){
            var that = this;
            if (this.phoneNum == "") {
              this.$message.warning("手机号不可为空");
              return false;
            }
            if (this.Mobile == this.phoneNum) {
              this.$message.warning("此手机号已绑定该账号，不可重复绑定");
              return false;
            }
            var myreg = /^[1][0-9]{10}$/;
            if (!myreg.test(this.phoneNum)) {
              this.$message.warning("请输入正确的手机号");
              return false;
            }
            this.$http
                .post("/api/XOrg/AOrgInfo/bindPhoneAfter", {
                    phoneNum: this.phoneNum
                })
                .then(function(rst) {
                    if (rst.code > 0) {
                        that.cancels();
                        that.$message.success(rst.msg);
                        that.getTecInfo();
                    } else {
                        that.$message.warning(rst.msg);
                    }
                });
        },
        cancels() {
          this.phoneNum = "";
        },
        // 发送短信
        sendMessage() {
          if (this.phoneNum == "") {
            this.$message.warning("手机号不可为空");
            return false;
          }
          if (this.Mobile == this.phoneNum) {
            this.$message.warning("此手机号已绑定该账号，不可重复绑定");
            return false;
          }
          var myreg = /^[1][0-9]{10}$/;
          if (!myreg.test(this.phoneNum)) {
            this.$message.warning("请输入正确的手机号");
            return false;
          }

          this.show4 = false;
          var once = true;
          let str_ = Date.parse(new Date()) / 1000;
          let str = this.encryption(str_);
          let str1 = CryptoJS.MD5(str_ + "").toString();

          var s1 = str1.substring(0, 7);
          var s2 = str1.substring(7);
          str1 = s1 + "s" + s2;

          if (once) {
            sendCode(this.phoneNum, str, str1).then(rst => {
              if (rst.code > 0) {
                this.$message.success(rst.msg);
                this.verifyCode = rst.verifyCode;
                const TIME_COUNT = 60;
                if (!this.timer) {
                  this.count = TIME_COUNT;
                  this.show1 = false;
                  this.show2 = true;
                  this.show3 = false;
                  this.timer = setInterval(() => {
                    if (this.count > 0 && this.count <= TIME_COUNT) {
                      this.count--;
                      once = false;
                    } else {
                      this.show1 = false;
                      this.show2 = false;
                      this.show3 = true;
                      clearInterval(this.timer);
                      this.timer = null;
                      once = true;
                    }
                  }, 1000);
                }
              } else {
                this.$message.warning(rst.msg);
                this.show1 = false;
                this.show2 = false;
                this.show3 = true;
                clearInterval(this.timer);
                this.timer = null;
                once = true;
              }
            });
          }
        },

        /** ************************ */
        encryption: function (str) {
          let Base64 = require("js-base64").Base64;
          return Base64.encode(str);
        },

        BindCellPhoneNumber() {
          // if (this.shortMessage == "") {
          //   this.$message.warning("请输入验证码");
          //   return false;
          // }
          bindCellPhoneNumber(
            this.phoneNum,
            this.shortMessage,
            this.verifyCode
          ).then(rst => {
            if (rst.code > 0) {
              this.$message.success(rst.msg);
              this.getTecInfo();
              this.EndBindPhone();
            } else {
              if (rst.code == -5) {
                this.$confirm("该账户已绑定其他手机号，是否更换？", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                  })
                  .then(() => {
                    this.$message({
                      type: "success",
                      message: "删除成功!"
                    });
                    this.BindPhoneAfter();
                  })
                  .catch(() => {
                    this.$message({
                      type: "info",
                      message: "已取消删除"
                    });
                  });
              } else {
                this.$message.warning(rst.msg);
                this.show1 = false;
                this.show2 = false;
                this.show3 = true;
                this.show4 = true;
                clearInterval(this.timer);
                this.timer = null;
              }
            }
          });
        },
        EndBindPhone() {
          this.phonedialogVisible = false;
          this.phoneNum = "";
          this.shortMessage = "";
          this.verifyCode = "";
          this.show4 = true;
          this.show1 = true;
          this.show2 = false;
          this.show3 = false;
          clearInterval(this.timer);
          this.timer = null;
        },
        BindPhoneAfter() {
          bindPhoneAfter(this.phoneNum).then(rst => {
            if (rst.code > 0) {
              this.$message.success(rst.msg);
              this.getTecInfo();
              this.EndBindPhone();
            } else {
              this.$message.warning(rst.msg);
              this.show1 = false;
              this.show2 = false;
              this.show3 = true;
              this.show4 = true;
              clearInterval(this.timer);
              this.timer = null;
            }
          });
        },
        //返回首页
        goHome() {
            this.$router.push({
                name: "xHome",
            });
        },
    },
};
</script>

<style lang="scss">
.le-tea-center {
    .le-center-content {
        width: 1200px;
        margin: 0 auto;
    }
    .nav-crumb-top {
        margin-top: 23px;
    }
    .change-user-password-form{
        width: 400px;
        margin: 15px auto 0;
        .el-input__inner{
            background-color: #f0f0f0;
            border: 1px solid #cccccc;
            color: #666666;
        }
    }
    .le-personal-center {
        background: #fff;
        margin-top: 20px;
        padding: 40px;
        box-sizing: border-box;
        border: 1px solid #f0f0f0;
    }
    .nav-sidebar-left {
        padding-left: 28px;
        border-bottom: 1px solid #f3f3f3;
    }
    .nav-sidebar-li {
        margin-right: 56px;
        padding-bottom: 19px;
        color: #409EFF;
        font-weight: bold;
        position: relative;
        cursor: pointer;
    }
    .active-tabs::before {
        content: "";
        position: absolute;
        bottom: 0;
        left: -5px;
        width: 40px;
        height: 2px;
        background: #409EFF;
    }
    .news-list-title {
        color: #333333;
        font-size: 18px;
    }
    .news-nav-left {
        color: #646464;
        font-size: 12px;
        i {
            color: #c9151d;
            font-size: 16px;
        }
        .nav-focus-text {
            color: #c9151d;
        }
    }
}

@media only screen and (max-width: 800px) {
    .le-tea-center {
        .le-center-content {
            width: 100%;
        }
        .le-personal-center{
            padding: 15px;
        }
        .change-user-password-form{
            width: 100%;
        }
    }
}
</style>
